import React, { useState } from 'react';
import { Button, Drawer } from 'ceci-ui';
import IssueChargeForm from '../IssueChargeForm';

const IssueChargeDrawerButton = () => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <Button variant="contained" onClick={() => setOpen(true)}>Nova cobrança</Button>
      <Drawer open={open} onClose={() => setOpen(false)}>
        <IssueChargeForm />
      </Drawer>
    </>
  )
};

export default IssueChargeDrawerButton;
